import {
  CheckCircleFilled,
  MinusCircleOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { Card, Divider, Flex, Row, Space, Spin, Upload } from "antd";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "components/elements";
import ModalCertificateOfEmployment from "components/elements/Modal/ModalCertificateOfEmployment";
import { Select } from "components/form";

import uploadStyles from "components/elements/upload/Upload.module.css";
import {
  beforeUpload,
  getBase64,
  uploadButton,
} from "components/elements/upload/Upload.utils";
import schema, {
  initialValues as INITIAL_VALUES,
} from "../schemas/companyDocumentSchema";
import myStyles from "../styles/CompanyDocument.module.css";
import styles from "../styles/CompanyProfile.module.css";
import { FormSelect } from "components/form/FormProvide";
import { Footer } from "antd/es/layout/layout";

const DocumentField = ({
  values = {},
  typeOfSlipOptions = [],
  setFieldValue = () => { },
  resetForm = () => { },
  onCancel = () => { },
  onSubmit = () => { }
}) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const { t, i18n } = useTranslation();

  const onLogoUpload = (info) => {
    setFieldValue("sealLogo", info.file);
    getBase64(info.file, (url) => {
      setLoading(false);
      setImageUrl(url);
    });
  };

  const onClearLogo = (e) => {
    e.stopPropagation();
    setFieldValue("sealLogo", null);
    setLoading(false);
    setImageUrl(null);
  };

  useEffect(() => {
    if (values.sealLogo) {
      setLoading(true);
      getBase64(values.sealLogo, (url) => {
        setImageUrl(url);
      });
    }
  }, [values.sealLogo]);

  return (
    <Card style={{ border: "solid 1px #EAECF0" }}>
      <Flex justify="space-between">
        <Flex>
          <b className={styles.infoTopic}>
            {" "}
            {t("document.label.document_template")}
          </b>
        </Flex>

        {/* <Flex>
          <Row justify="end" className={styles.container}>
            <Space size={20} direction="horizontal">
              <Button
                type="default"
                onClick={() => {
                  resetForm();
                  onCancel();
                }}
              >
                {t("common.cancel").toUpperCase()}
              </Button>
              <Button htmlType="submit" onClick={() => onSubmit}>
                {t("common.submit").toUpperCase()}
              </Button>
            </Space>
          </Row>
        </Flex> */}
      </Flex>

      <Divider />
      <div className={myStyles.withdrawalContainer}>
        <label>{t("document.label.type_of_slip")}</label>
        <Select
          name="typeOfSlip"
          size="large"
          placeholder={t('please-select-1')}
          options={typeOfSlipOptions}
        />
        <label>{t("document.label.size")}</label>
        <Select
          name="paySlipSize"
          size="large"
          placeholder={t('please-select-1')}
          options={[
            { label: "A1", value: "A1" },
            { label: "A2", value: "A2" },
            { label: "A3", value: "A3" },
            { label: "A4", value: "A4" },
            { label: "A5", value: "A5" },
          ]}
        />
        <label>{t("document.label.seal_logo")}</label>
        {imageUrl ? (
          <div className={myStyles.sealContainer}>
            <MinusCircleOutlined
              className={myStyles.miniMinusBtn}
              style={{
                position: "absolute",
                bottom: "-12px",
                right: "-12px",
              }}
              onClick={onClearLogo}
            />
            <img
              src={imageUrl}
              alt=""
              style={{ width: "100%", borderRadius: "10px" }}
            />
          </div>
        ) : (
          <Upload
            name="sealLogo"
            className={uploadStyles.containerSecond}
            showUploadList={false}
            beforeUpload={beforeUpload}
            onChange={onLogoUpload}
            action={null}
          >
            {uploadButton(loading)}
          </Upload>
        )}
      </div>
    </Card>
  );
};

const SignatureField = ({
  label = "",
  values = [],
  isLoading = false,
  onEdit = () => { },
  onCreate = () => { },
}) => {
  const { i18n } = useTranslation();

  return values.map((value, index) => {
    const { authorized = {} } = value;
    return (
      <React.Fragment key={index}>
        {index === 0 ? <label>{label}</label> : <div />}
        <p
          style={isLoading ? { cursor: "wait" } : { cursor: "pointer" }}
          onClick={() => {
            if (isLoading) return;
            if (value.documentSignatureId) onEdit(value);
          }}
        >
          {i18n.language === "en" ? authorized.nameEn : authorized.name}
        </p>
        <div className={myStyles.signature}>
          {value.signature ? (
            <CheckCircleFilled className={myStyles.checked} />
          ) : (
            "-"
          )}
          <Space
            className={myStyles.btnContainer}
            size={4}
            direction="vertical"
            align="center"
          >
            {index === values.length - 1 ? (
              <PlusCircleOutlined
                className={myStyles.miniBtn}
                onClick={() => onCreate(value)}
              />
            ) : (
              <div />
            )}
          </Space>
        </div>
      </React.Fragment>
    );
  });
};

function CompanyDocumentEdit({
  isLoading = false,
  isLoadingData = false,
  initialValues = {},
  employeeOptions = [],
  currentSignature = {},
  typeOfSlipOptions = [],
  isEditCertificate = false,
  isCreateCertificate = false,
  selectedDocumentSignature = {},
  onCancel = () => { },
  onSubmit = () => { },
  onEditSignature = () => { },
  onCreateSignature = () => { },
  onCancelSignature = () => { },
  onSubmitEditSignature = () => { },
  onSubmitCreateSignature = () => { },
  onSubmitTemplate = () => { }
}) {
  const { t, i18n } = useTranslation();

  return (
    <Spin spinning={isLoadingData || isLoading}>
      <ModalCertificateOfEmployment
        isModalOpen={isCreateCertificate || isEditCertificate}
        employeeOptions={employeeOptions}
        initialValues={isCreateCertificate ? selectedDocumentSignature : isEditCertificate ? currentSignature : {}}
        onSubmit={isCreateCertificate ? onSubmitCreateSignature : isEditCertificate ? onSubmitEditSignature : () => { }}
        onCancel={onCancelSignature}
        type={isCreateCertificate ? 'create' : isEditCertificate ? 'edit' : ''}
      />

      <Formik
        enableReinitialize
        initialValues={{
          ...INITIAL_VALUES,
          ...initialValues,
        }}
        onSubmit={onSubmit}
        validationSchema={schema}
      >
        {({ values = {}, setFieldValue = () => { }, resetForm = () => { } }) => {
          return (
            <Form className={myStyles.form}>
              <Space
                className={styles.container}
                size={24}
                direction="vertical"
              >
                {/* <Row justify="end" className={styles.container}>
                  <Space size={20} direction="horizontal">
                    <Button
                      type="default"
                      onClick={() => {
                        resetForm();
                        onCancel();
                      }}
                    >
                      {t("common.cancel").toUpperCase()}
                    </Button>
                    <Button htmlType="submit">
                      {t("common.submit").toUpperCase()}
                    </Button>
                  </Space>
                </Row> */}
                <DocumentField
                  values={values}
                  typeOfSlipOptions={typeOfSlipOptions}
                  setFieldValue={setFieldValue}
                  resetForm={resetForm}
                  onCancel={onCancel}
                  onSubmit={onSubmit}
                />
                <Card style={{ border: "solid 1px #EAECF0" }}>
                  <Flex justify="space-between">
                    <Flex>
                      <b className={styles.infoTopic}>
                        {t("document.label.document_signature")}
                      </b>
                    </Flex>
                    {/* <Flex>
                      <Row justify="end" className={styles.container}>
                        <Space size={20} direction="horizontal">
                          <Button
                            type="default"
                            onClick={() => {
                              resetForm();
                              onCancel();
                            }}
                          >
                            {t("common.cancel").toUpperCase()}
                          </Button>
                          <Button htmlType="submit">
                            {t("common.submit").toUpperCase()}
                          </Button>
                        </Space>
                      </Row>
                    </Flex> */}
                  </Flex>

                  <Divider />
                  <div className={myStyles.documentSignatureContainer}>

                    <p>
                      <b>{t("document.label.document_type")}</b>
                    </p>
                    <p>
                      <b>{t("document.label.authorize")}</b>
                    </p>
                    <p>
                      <b>{t("document.label.signature")}</b>
                    </p>

                    {Object.entries(
                      initialValues.documentSignatureResponse
                    ).map(([_, value]) => {
                      const firstVal = value[0] || {};
                      console.log('first', firstVal);
                      const label = firstVal.documentSignatureId
                        ? i18n.language === "en"
                          ? firstVal.documentTypeNameEn
                          : firstVal.documentTypeName
                        : firstVal.documentTypeName;
                      return (
                        <SignatureField
                          label={label}
                          values={value}
                          isLoading={isLoading}
                          onEdit={onEditSignature}
                          onCreate={onCreateSignature}
                        />
                      );
                    })}
                  </div>
                </Card>
              </Space>
              <Footer style={{
                zIndex: 999,
                bottom: 1,
                position: 'sticky',
                backgroundColor: 'white',
                height: "fit-content",
                padding: '10px 50px',
              }}>
                <Row justify="end" style={{ gap: "12px" }}>
                  <Button type="default" onClick={() => {
                    onCancel()
                  }} style={{ height: "40px", borderRadius: "8px", padding: "8px 16px" }}
                  >
                    {t("common.cancel").toUpperCase()}
                  </Button>
                  <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}>
                    {t("common.submit").toUpperCase()}
                  </Button>
                </Row>
              </Footer>
            </Form>
          );
        }}
      </Formik>
    </Spin>
  );
}

export default CompanyDocumentEdit;
